import React from 'react'
import Skeleton from 'react-loading-skeleton'

export const SkeletonBox = () => {
  return <Skeleton key={0} width="100%" height="160px" style={{ borderRadius: '20px' }} />
}
